function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148948",
  "data-name": "Path 148948",
  d: "M13.991,22.742A9.088,9.088,0,1,0,4.9,13.654,9.147,9.147,0,0,0,13.991,22.742Zm0-13.711a4.485,4.485,0,0,0-2.162.545L9.9,7.634a7.345,7.345,0,0,1,8.218.018L16.188,9.585A4.656,4.656,0,0,0,13.991,9.031Zm-7.26,4.623a7.269,7.269,0,0,1,1.23-4.078L9.9,11.51a4.613,4.613,0,0,0,.026,4.333L8,17.776A7.261,7.261,0,0,1,6.731,13.654Zm11.892,0a4.563,4.563,0,0,0-.527-2.127l1.934-1.934a7.24,7.24,0,0,1,1.239,4.061,7.314,7.314,0,0,1-1.257,4.113l-1.942-1.942A4.526,4.526,0,0,0,18.623,13.654ZM14,16.687a3.032,3.032,0,1,1,3.032-3.032A3.027,3.027,0,0,1,14,16.687Zm-.009,4.245A7.3,7.3,0,0,1,9.931,19.7l1.942-1.942A4.694,4.694,0,0,0,14,18.277a4.626,4.626,0,0,0,2.136-.527l1.942,1.934A7.243,7.243,0,0,1,13.991,20.932Z",
  transform: "translate(-4.903 -4.566)",
  fill: "currentColor"
});

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.185,
    height: 18.176,
    viewBox: "0 0 18.185 18.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.3c4dac8d.svg";
export { ForwardRef as ReactComponent };